import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/messages';

const messagesService = {
  // Funkcja do wysyłania wiadomości
  async sendMessage(senderId, receiverId, content) {
    try {
      const response = await axios.post(
        `${API_URL}/send`,
        null, // nie przesyłamy body, używamy parametru URL
        {
          params: {
            senderId,
            receiverId,
            content,
          },
        }
      );
      return response.data; // Zwracamy odpowiedź z serwera (wiadomość)
    } catch (error) {
      console.error("Błąd podczas wysyłania wiadomości:", error);
      throw error;
    }
  },

  async sendMessageFromDriver(driverId, content) {
    try {
      await axios.post(
        `${API_URL}/send-from-driver`,
        null,
        {
          params: {
            driverId,
            content,
          },
        }
      );
    } catch (error) {
      console.error("Błąd podczas wysyłania wiadomości:", error);
      throw error;
    }
  },

  // Funkcja do pobierania historii czatu
  async getChatHistory(senderId, receiverId) {
    try {
      const response = await axios.get(`${API_URL}/chat`, {
        params: {
          senderId,
          receiverId,
        },
      });
      return response.data; // Zwracamy historię wiadomości
    } catch (error) {
      console.error("Błąd podczas pobierania historii czatu:", error);
      throw error;
    }
  },

  // Funkcja do pobierania wszystkich wiadomości dla użytkownika
  async getUserMessages(userId) {
    try {
      const response = await axios.get(`${API_URL}/user/${userId}`);
      return response.data; // Zwracamy wszystkie wiadomości
    } catch (error) {
      console.error("Błąd podczas pobierania wiadomości użytkownika:", error);
      throw error;
    }
  },

  async getLastMessage(dispatcherId, driverId) {
    try {
      const response = await axios.get(`${API_URL}/last-message`, {
        params: {
          dispatcherId,
          driverId,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Błąd podczas pobierania ostatniej wiadomości:", error);
      throw error;
    }
  },

    async getChatByReceiver(receiverId) {
    try {
      const response = await axios.get(`${API_URL}/by-receiver`, {
        params: {
          receiverId,
        },
      });
      return response.data; // Zwracamy historię wiadomości
    } catch (error) {
      console.error("Błąd podczas pobierania historii czatu:", error);
      throw error;
    }
  },
};

export default messagesService;
